import api from './api';

// class with functions for geolocation api calls 

class GeolocationService {

  //get list of countries 
  getCountries() {
    return api.get('reports/countries');
  }

  //get countries by coordinates 
  getCountriesByCoords(coords) {
    // console.log("coords: ", coords);
    return api.get('reports/countries/' + coords.latitude + '/' + coords.longitude);
  }

  //get list of cities by country and coordinates 
  getCitiesByCountryAndCoords(country, lat, long) {
    return api.get('reports/cities/' + country + '/' + lat + '/' + long);
  }

  //get list of cities by country 
  getCitiesByCountry(country) {
    return api.get('reports/cities/' + country);
  }

}

export default new GeolocationService();
